/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type DevicesImportControllerImportCsvParams = {
  /**
   * Building UUID
   */
  buildingId: string;
  /**
   * Floor space UUID under the building
   */
  floorId: string;
  /**
   * Room space UUID on the floor (floorId)
   */
  roomId: string;
};
